var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenCheck = function SvgGreenCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B6E1C9",
    fillRule: "evenodd",
    d: "M12 32c0-11.046 8.954-20 20-20s20 8.954 20 20-8.954 20-20 20-20-8.954-20-20",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DD7B7",
    d: "M12 32c0-11.046 8.954-20 20-20v40c-11.046 0-20-8.954-20-20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B9D4D",
    d: "m28.224 38.257.023.025c.79.82 2.07.82 2.86 0l8.577-8.905c.79-.82.79-2.15 0-2.969a1.97 1.97 0 0 0-2.86 0l-7.147 7.421-2.502-2.597a1.97 1.97 0 0 0-2.859 0c-.79.82-.79 2.148 0 2.968z"
  })));
};
export default SvgGreenCheck;